import { DraftConfiguration } from '@/types';
import { getIsEmptyOrDefaultText } from './getIsEmptyOrDefaultText';
import { getIsOutsideSoftBoundary } from './getIsOutsideSoftBoundary';

export const getIsUnprintableConfiguration = (configuration: DraftConfiguration) =>
  getIsEmptyOrDefaultText(configuration) || getIsOutsideSoftBoundary(configuration);
